module.exports = __webpack_public_path__ + "static/media/ic_pdf.5c323acb.svg";